import { Component, inject, OnInit } from '@angular/core';

import { ChartModule } from 'primeng/chart';
import { FluidModule } from 'primeng/fluid';
import { DashboardService } from '../services/api/dashboard.service';
import { AuthService } from '../../../core/services/api/auth.service';

@Component({
    selector: 'app-graphloans',
    imports: [ChartModule, FluidModule],
    templateUrl: './graphloans.component.html',
    styleUrl: './graphloans.component.scss'
})
export class GraphloansComponent implements OnInit {
    private _dashboardService = inject(DashboardService);
    private _authService = inject(AuthService);

    lineData: any;
    lineOptions: any;
    datasets: any;
    labels: string[] = [];
    data: number[] = [];

    /** Sucursal del usuario logueado (nombre tal como viene en el gráfico). */
    private currentBranch: string = (this._authService.getCurrentUser()?.branch || '').trim().toLowerCase();

    /** true si el label del gráfico corresponde a la sucursal del usuario. */
    private isCurrentBranch(label: string): boolean {
        return !!this.currentBranch && (label || '').trim().toLowerCase() === this.currentBranch;
    }

    constructor() {}

    ngOnInit(): void {
        this._dashboardService.getDatosGraphBranches().subscribe((resp) => {
            if (resp.status) {
                console.log(resp);

                this.datasets = resp.object;

                this.datasets.forEach((element: any) => {
                    this.labels.push(element.branchName);
                    this.data.push(element.patientCount);
                });

                console.log(this.labels, this.data);
                this.initCharts();
            }
        });
    }

    initCharts() {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
        const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

        const primaryColor = documentStyle.getPropertyValue('--p-primary-500');
        // La sucursal del usuario se resalta en naranja. Si su sucursal es
        // for_reports = false no aparece en el gráfico, por lo que no se resalta nada.
        const highlightColor = documentStyle.getPropertyValue('--p-orange-500') || '#f97316';
        const pointBackgroundColor = this.labels.map((label) => (this.isCurrentBranch(label) ? highlightColor : primaryColor));
        const pointBorderColor = this.labels.map((label) => (this.isCurrentBranch(label) ? highlightColor : primaryColor));
        const pointRadius = this.labels.map((label) => (this.isCurrentBranch(label) ? 7 : 3));
        const pointHoverRadius = this.labels.map((label) => (this.isCurrentBranch(label) ? 9 : 5));

        this.lineData = {
            // labels: ['Caacupé', 'Capiata', 'Carapegua', 'Centro', 'Itauguá', 'Laboratorio', 'Lambaré', 'Luque', 'MRA', 'Ñemby', 'San Lorenzo', 'San Pablo'],
            labels: this.labels,
            datasets: [
                {
                    label: 'Pacientes Atendidos',
                    // data: [10, 35, 15, 70, 50, 10, 75, 100, 120, 90, 135, 88],
                    data: this.data,
                    fill: false,
                    backgroundColor: primaryColor,
                    borderColor: primaryColor,
                    tension: 0.4,
                    pointBackgroundColor,
                    pointBorderColor,
                    pointRadius,
                    pointHoverRadius
                }
            ]
        };

        this.lineOptions = {
            maintainAspectRatio: false,
            aspectRatio: 0.8,
            plugins: {
                legend: {
                    labels: {
                        color: textColor
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder,
                        drawBorder: false
                    }
                },
                y: {
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder,
                        drawBorder: false
                    }
                }
            }
        };
    }
}
